// utils/geo.js
export const DEPT_DICT = {
  "01":"Ain","02":"Aisne","03":"Allier","04":"Alpes-de-Haute-Provence","05":"Hautes-Alpes",
  "06":"Alpes-Maritimes","07":"Ardèche","08":"Ardennes","09":"Ariège","10":"Aube",
  "11":"Aude","12":"Aveyron","13":"Bouches-du-Rhône","14":"Calvados","15":"Cantal",
  "16":"Charente","17":"Charente-Maritime","18":"Cher","19":"Corrèze","21":"Côte-d'Or",
  "22":"Côtes-d'Armor","23":"Creuse","24":"Dordogne","25":"Doubs","26":"Drôme",
  "27":"Eure","28":"Eure-et-Loir","29":"Finistère","2A":"Corse-du-Sud","2B":"Haute-Corse",
  "30":"Gard","31":"Haute-Garonne","32":"Gers","33":"Gironde","34":"Hérault",
  "35":"Ille-et-Vilaine","36":"Indre","37":"Indre-et-Loire","38":"Isère","39":"Jura",
  "40":"Landes","41":"Loir-et-Cher","42":"Loire","43":"Haute-Loire","44":"Loire-Atlantique",
  "45":"Loiret","46":"Lot","47":"Lot-et-Garonne","48":"Lozère","49":"Maine-et-Loire",
  "50":"Manche","51":"Marne","52":"Haute-Marne","53":"Mayenne","54":"Meurthe-et-Moselle",
  "55":"Meuse","56":"Morbihan","57":"Moselle","58":"Nièvre","59":"Nord",
  "60":"Oise","61":"Orne","62":"Pas-de-Calais","63":"Puy-de-Dôme","64":"Pyrénées-Atlantiques",
  "65":"Hautes-Pyrénées","66":"Pyrénées-Orientales","67":"Bas-Rhin","68":"Haut-Rhin","69":"Rhône",
  "70":"Haute-Saône","71":"Saône-et-Loire","72":"Sarthe","73":"Savoie","74":"Haute-Savoie",
  "75":"Paris","76":"Seine-Maritime","77":"Seine-et-Marne","78":"Yvelines","79":"Deux-Sèvres",
  "80":"Somme","81":"Tarn","82":"Tarn-et-Garonne","83":"Var","84":"Vaucluse",
  "85":"Vendée","86":"Vienne","87":"Haute-Vienne","88":"Vosges","89":"Yonne",
  "90":"Territoire de Belfort","91":"Essonne","92":"Hauts-de-Seine","93":"Seine-Saint-Denis","94":"Val-de-Marne",
  "95":"Val-d'Oise","971":"Guadeloupe","972":"Martinique","973":"Guyane","974":"La Réunion","975":"Saint-Pierre-et-Miquelon",
  "976":"Mayotte","977":"Saint-Barthélemy","978":"Saint-Martin"
};

export function extractDeptFromInsee(code) {
  if (!code) return null;
  const s = String(code).toUpperCase();
  if (/^(97|98)/.test(s)) return s.slice(0, 3);
  if (/^(2A|2B)/.test(s)) return s.slice(0, 2);
  return s.slice(0, 2);
}

const SMALL_WORDS = new Set([
  "de","du","des","le","la","les","l'","l’","d'","d’","au","aux","en","et","à","a","sur","sous","chez","sans","avec"
]);

export function capWord(w, isFirst=false) {
  if (!w) return w;
  const apos = w.includes("’") ? "’" : "'";
  if (w.includes("'") || w.includes("’")) {
    const parts = w.split(/['’]/);
    return parts
      .map((p, i) => (i === 0 ? p.toLowerCase() : (p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())))
      .join(apos);
  }
  const low = w.toLowerCase();
  if (!isFirst && SMALL_WORDS.has(low)) return low;
  return low.charAt(0).toUpperCase() + low.slice(1);
}

function capHyphenated(token, isFirst=false) {
  return token
    .split(/-+/)
    .map((part, idx) => {
      const low = part.toLowerCase();
      if (low === "st" || low === "st.") return "Saint";
      if (low === "ste" || low === "ste.") return "Sainte";
      const firstHere = isFirst && idx === 0;
      return capWord(part, firstHere);
    })
    .join("-");
}

export function deriveCommuneName(data) {
  const raw =
    (data?.adresse?.nom_commune ? String(data.adresse.nom_commune) : "") ||
    (data?.ban_id ? String(data.ban_id) : "");
  if (!raw) return "";
  let src = raw;
  if (!data?.adresse?.nom_commune && data?.ban_id) {
    const parts = raw.trim().split(/\s+/);
    src = parts.length >= 3 ? parts[parts.length - 3] : raw;
  }
  const cleaned = src.trim().replace(/\s+/g, " ");
  return cleaned
    .split(" ")
    .map((tok, i) => capHyphenated(tok, i === 0))
    .join(" ");
}
